/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<0777688766085bb8b86a79b5a783f602>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from "relay-runtime";
import type { FragmentRefs } from "relay-runtime";
export type topicFragment$data = {
  readonly items: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly ari: string;
        readonly data: {
          readonly __typename: string;
        } | null;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"helpObject">;
    } | null> | null;
  } | null;
  readonly name: string | null;
  readonly topicId: string;
  readonly " $fragmentType": "topicFragment";
};
export type topicFragment$key = {
  readonly " $data"?: topicFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "topicFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "topicId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HelpCenterTopicItemConnection",
      "kind": "LinkedField",
      "name": "items",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "HelpCenterTopicItemEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "helpObject"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "HelpCenterTopicItem",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "ari",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "data",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "HelpCenterTopic",
  "abstractKey": null
};

(node as any).hash = "415155638a6737f20aafdbe5b100243c";

export default node;
